<div class="top-title">
    <span class="back-btn mx-4 my-2"  (click)="back()">
        <img class="px-2" width="30px" src="assets/images/back_arrow.svg" alt=""> Back
      </span>
       <span class="text-xl font-semibold">Online Store Templates</span>
       <span class="hide-btn mx-4"  (click)="back()">
        hide
      </span>
</div>
<div class="flex flex-column justify-content-center py-5 align-items-center">
    <h2>Select your template
    </h2>
    <p class="col-7 " style="text-align: center;">
        Website templates are perfect for a quick store. Select the template you like and change whatever you want, like colors, fonts, and images. Personalize the template for your business, and your site is ready to publish.
    </p>
</div>
<div class="grid-container">

    <div *ngFor="let store of _globals?.webStoreConfiguration" class="grid-item flex justify-content-center box theme-container animated-bg" [style.background-image]="'url(' + store?.imageUrl+ ')'">
        <div class="flex align-items-end theme-button-container" >
         <span class="m-1 w-full "    [ngClass]="store?.isAvailable === true ? 'usetheme-btn': 'disabled'"  (click)="setTheme('use',store)">
            Use Template
         </span>
         <span class="m-1 w-full " [ngClass]="store?.isAvailable === true ? 'preview-btn': 'disabled'"   (click)="setTheme('preview',store)">
            Preview Template
         </span>
        </div> </div>

</div>
<div class="flex justify-content-end align-content-center m-5 ">
</div>

<p-dialog [showHeader]="false" [(visible)]="displayConfirmContinueDialog" [style]="{width: '40vw'}" modal="true"
    [baseZIndex]="10000" class="p3" >

    <div class="modal p-4">
      <div class="modal-header justify-content-center">
        <h3>Your Template Is Ready to Customize!</h3>
        <!-- <i class="pi pi-times p-2 cursor-pointer" (click)="closeModal()"></i> -->
      </div>
      <div class="modal-body">
      <p>
          Your online store is all set up with the new template! You can start editing it right away to match your brand or preview how it looks to customers.
        </p>
      </div>
      <div class="modal-footer">
        <span class="cancel-btn mx-2" (click)="confirmWebsite()"> View your store <i class="pi pi-arrow-up-right px-1"></i></span>
        <span class="confirm-btn" (click)="confirmEditor()"> Customize your store <i class="pi pi-arrow-up-right px-1"></i></span>
      </div>
    </div>
</p-dialog>


<p-dialog [showHeader]="false" [(visible)]="showConfirmation" [style]="{width: '40vw'}" modal="true"
    [baseZIndex]="10000" class="p3" >

    <div class="modal p-4">
      <div class="modal-header justify-content-between">
        <div class="center-content">
          <h3>Confirm Template Selection</h3>
        </div>

        <div class="right-content">
          <i class="pi pi-times p-2 cursor-pointer" (click)="closeModal()"></i>
        </div>
      </div>
      <div class="modal-body">
        <!-- <i class="pi pi-info-circle text-4xl px-3"></i> -->
        <p>
          Template selection is a one-time action and can’t be changed later; however, you can customize the template to fit your needs.
        </p>
      </div>
      <div class="modal-footer">
        <span class="cancel-btn" (click)="closeModal()"> <i class="pi pi-times px-1"></i> Cancel</span>
        <span class="confirm-btn" (click)="confirmTheme()"> <i class="pi pi-check px-1"></i> Confirm Template</span>
      </div>
    </div>
</p-dialog>
